import styled from '@emotion/styled';
import {
    breakpoints,
    fontSizes,
    fontWeights,
    colors,
    colorVariables,
    mediaQuery,
    gutterSizes,
} from '@gumtree/ui-library/src/base/theme';

export const BarkCardWrapper = styled.div`
    padding: ${gutterSizes.xxlarge} ${gutterSizes.xlarge} 0 ${gutterSizes.xlarge};

    display: flex;
    flex-direction: column; /* Mobile first: stack vertically */
    align-items: center;
    
    text-align: center;

    ${mediaQuery.until(breakpoints.medium)} { /* m */
        flex-direction: row;
        text-align: left;
        align-items: center;
        background-color: ${colorVariables.backgroundLighter};
        margin-left: -17px;
        margin-right: -17px;
        padding: 18px 16px;
    }
`;

export const AvatarImage = styled.img`
    border-radius: 50%;
    object-fit: cover;

    ${mediaQuery.from(breakpoints.medium)} { /* PC */
        width: 132px;
        height: 132px;
    }
    ${mediaQuery.until(breakpoints.medium)} {
        width: 72px;
        height: 72px;
    }
`;

export const InfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;


    ${mediaQuery.from(breakpoints.medium)} { /* PC/Tablet view */
        margin-top: 16px;
        align-items: center;
    }
    ${mediaQuery.until(breakpoints.medium)} {
        margin-left: 8px;
    }
`;

export const CompanyName = styled.a`
    display: block;
    font-size: ${fontSizes.base};
    font-weight: ${fontWeights.bold};
    color: ${colors.navy};
    text-decoration: underline;
    cursor: pointer;

    &:hover {
        color: #007bff;
    }
`;

export const RatingWrapper = styled.div`
    display: flex;
    align-items: center;
    color: #555;

    ${mediaQuery.from(breakpoints.medium)} { /* PC */
        margin-top: 8px;
    }
`;

export const RatingText = styled.span`
    font-size: 1em; // 16px
`;

export const PoweredByWrapper = styled.div`
    display: flex;
    align-items: center;
    font-size: 0.875em; // 14px
    color: #777;

    ${mediaQuery.from(breakpoints.medium)} { /* PC */
        margin-top: 8px;
    }
`;

export const BarkLogo = styled.a`
    font-weight: bold;
    color: #333; // Or Bark's brand color
    text-decoration: none;
    margin: 0 4px;

    &:hover {
        text-decoration: underline;
    }
`;

export const NoImgWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    
    ${mediaQuery.from(breakpoints.medium)} { /* PC */
        width: 132px;
        height: 132px;
    }
    ${mediaQuery.until(breakpoints.medium)} { /* m */
        width: 74px;
        height: 74px;
    }

    & > svg, & > img {
        width: 100%;
        height: 100%;
        display: block;
    }
`;
